import { createReducer, on } from '@ngrx/store';

import { driversAdapter, initialDriversState } from '@store/drivers/drivers.state';

import {
  addDriver,
  deleteDriver,
  loadDrivers,
  loadDriversFailure,
  loadDriversSuccess,
  setLastPageStateDrivers,
  updateDriver,
  updateMultipleDrivers,
} from './drivers.actions';

export const driversReducer = createReducer(
  initialDriversState,
  on(loadDrivers, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadDriversSuccess, (state, { list }) =>
    driversAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadDriversFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addDriver, (state, { driver }) => driversAdapter.addOne(driver, state)),
  on(updateDriver, (state, { id, changes }) =>
    driversAdapter.updateOne({ id: +id, changes }, state),
  ),
  on(updateMultipleDrivers, (state, { updates }) =>
    driversAdapter.updateMany(
      updates.map(({ id, changes }) => ({ id: +id, changes })),
      state,
    ),
  ),
  on(deleteDriver, (state, { id }) => driversAdapter.removeOne(+id, state)),
  on(setLastPageStateDrivers, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),
);
